import { render } from "./ListaCompras.vue?vue&type=template&id=7ed9b351"
import script from "./ListaCompras.vue?vue&type=script&lang=js"
export * from "./ListaCompras.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__